<template>
    <div style="height:1500px; margin-left: 90px; margin-top: 100px;">
        <v-layout row wrap>
            <v-flex xs12 md3>
                <v-select name="firstYear" v-bind:label="$t('message.firstYear')" v-validate="'required'"
                    item-text="Valor" :items="yearList" v-model="firstYear"></v-select>
            </v-flex>


            <v-flex xs12 md3>
                <v-select name="secondYear" v-bind:label="$t('message.secondYear')" v-validate="'required'"
                    item-text="Valor" :items="yearList" v-model="secondYear"></v-select>
            </v-flex>

            <v-flex xs12 md3 style="margin-top: 20px;">
                <v-btn style="height:50%" class="hidden-xs-only" small color="accent"
                    @click="CargaInformacion()">Consultar</v-btn>
            </v-flex>


        </v-layout>

        <ChartCorporativoIngresoPorAnio :width="1400" :height="550" :firstYearSelect="firstYear"
            :secondYearSelect="secondYear" :dataGrafic="dataGrafic">
        </ChartCorporativoIngresoPorAnio>

        <h5> Nota :El presupuesto que se refleja toma en
            cuenta negocios facultativos </h5>

        <div style=" background-color:#3AA9E0; width: 95%;height: 30px;">
            <h4 style="color: white;width: 90%;margin-top: 20px;padding-top: 7px;padding-left: 10px;">PRESUPUESTOS E
                INGRESOS ACUMULADOS</h4>
        </div>
        <v-layout row wrap>
            <v-flex xs12 md6>
            </v-flex>


            <v-flex xs12 md3>
                <v-layout row wrap>
                    <v-flex xs12 md2 style="background-color: #3AA9E0; height: 90%;">

                    </v-flex>
                    <v-flex xs12 md6>
                        <h3>Primer Año</h3>
                    </v-flex>

                </v-layout>


            </v-flex>

            <v-flex xs12 md3>
                <v-layout row wrap>
                    <v-flex xs12 md2 style="background-color: #000349; height: 90%;">

                    </v-flex>
                    <v-flex xs12 md6>
                        <h3>Segundo Año</h3>
                    </v-flex>

                </v-layout>


            </v-flex>

        </v-layout>
        <v-data-table :headers="headers" :items="presupuestosList" class="elevation-1" style="width: 95%;">
            <template slot="items" scope="props">

                <td class="text-xs-left cut-text" style="padding-left:10px">{{ props.item.Nombre }}</td>
                <td class="text-xs-center cut-text">{{ Number(props.item.PrimerAnio).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
                <td class="text-xs-center cut-text">{{ Number(props.item.SegundoAnio).toLocaleString(undefined, {minimumFractionDigits: 2})  }}</td>

            </template>

        </v-data-table>

    </div>

</template>
<script>
import { mapGetters } from "vuex";
import ChartCorporativoIngresoPorAnio from "./ChartCorporativoIngresoPorAnio";
import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";
import CatalogServices from "@/services/CatalogsServices";
import { EventBus } from "@/imports/EventBus";
export default {
    async beforeMount() {
        var today = new Date();
        var anioActual = today.getFullYear() - 1;
        var anioAtras = today.getFullYear() - 2;
        this.firstYear = anioActual.toString();
        this.secondYear = anioAtras.toString();


    },

    async mounted() {

        // this.sucursal = 1;
        // this.$root.$emit(
        //     "showLoading",
        //     "Cargando Ingreso por año de cumplimiento"
        // );
        // await this.CargaInformacion();
        // this.$root.$emit("hideLoading");




    },
    components: {
        ChartCorporativoIngresoPorAnio


    },
    computed: {
        ...mapGetters(["agency", "userProfile", "agencyId", "agencyName"]),

    }
    , methods: {
        async getApsInfo(apsId) {

            let idAps = "";
            await CatalogServices.getDataApsInfo()

            .then((response) => {
                idAps = response.data.data.filter(({ codeSiaerp }) => (codeSiaerp == apsId))[0]["code"]
                

            }).catch(()=>{
                this.$root.$emit("hideLoading");
                this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
            })
            if(idAps == "" || idAps == undefined || idAps == null ){
            this.$root.$emit("showSnackBar", "No se encontro idAps", "error");
            this.$root.$emit("hideLoading");
            }

            return idAps;
        },

        async CargaInformacion() {
            this.$root.$emit(
                "showLoading",
                "Cargando Ingreso por año de cumplimiento"
            );
            var broker = await this.getApsInfo(this.userProfile.user_id);

            await CommercialGraphicsServices.getComparateYearGraphic(this.firstYear, this.secondYear,broker).then((response) => {

                this.dataGrafic = response.data.data.Data[0];

                var dataFirstYear = this.dataGrafic.PrimerAnio;
                var dataSecondYear = this.dataGrafic.SegundoAnio;

                this.presupuestosList = [
                    {
                        Nombre: 'Presupuesto a la Fecha',
                        PrimerAnio: dataFirstYear.Presupuesto,
                        SegundoAnio: dataSecondYear.Presupuesto,
                    },
                    {
                        Nombre: 'Producción',
                        PrimerAnio: dataFirstYear.Produccion,
                        SegundoAnio: dataSecondYear.Produccion,
                    },
                    {
                        Nombre: 'Ingresos',
                        PrimerAnio: dataFirstYear.Ingreso,
                        SegundoAnio: dataSecondYear.Ingreso,
                    },
                ];

            }).catch(res => {
                this.$root.$emit("hideLoading");
                this.$root.$emit("showSnackBar", "Error desconocido", "error");
            });
            await EventBus.$emit("ChartCorporativoIngresoPorAnio");
            this.$root.$emit("hideLoading");
        }
    }
    , data() {
        var today = new Date();
        return {
            dataGrafic: {},
            chartLoaded: false,
            catalogTypeOfLineBusiness: [],
            catalogTypeOfProductionList: [],
            yearComercial: null,
            typeProduction: null,
            startWeek: 1,
            endWeek: 52,
            lineBusiness: null,
            sucursal: 1,
            presupuestosList: [
                {
                    Nombre: 'Presupuesto a la Fecha',
                    PrimerAnio: '0',
                    SegundoAnio: '0',
                },
                {
                    Nombre: 'Producción',
                    PrimerAnio: '0',
                    SegundoAnio: '0',
                },
                {
                    Nombre: 'Ingresos',
                    PrimerAnio: '0',
                    SegundoAnio: '0',
                },
            ],
            firstYear: null,
            secondYear: null,
            firstYearSelect: "" + today.getFullYear() - 1,
            secondYearSelect: "" + today.getFullYear() - 2,
            headers: [
                {
                    align: "center",
                    sortable: false,
                    text: "",
                    value: "Nombre",
                    width: "18%"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Primer Año",
                    value: "PrimerAnio",
                    width: "14%",
                    class: "table-header-PrimerAnio"
                },
                {
                    align: "center",
                    sortable: false,
                    text: "Segundo Año",
                    value: "SegundoAnio",
                    width: "14%",
                    class: "table-header-SegundoAnio"
                },


            ],
            yearList: [
                "2012",
                "2013",
                "2014",
                "2015",
                "2016",
                "2017",
                "2018",
                "2019",
                "2020",
                "2021",
                "2022",
                "2023",
                "2024",
                "2025",
                "2026",
                "2027",
                "2028",
                "2029",
                "2030",
                "2031",
                "2032",
                "2033",
                "2034",
                "2035",
                "2036",
                "2037",
                "2038",
                "2039",
                "2040",
                "2041",
                "2042",
                "2043",
                "2044",
                "2045",
                "2046",
                "2047",
                "2048",
                "2049",
                "2050"
            ],

        }
    }

}
</script>
<style lang="scss">
.table-header-PrimerAnio {
    background-color: #3AA9E0;
}

.table-header-SegundoAnio {
    background-color: #000349;
}
</style>